import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const MEASUREMENT_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID

const GoogleAnalyticsRouteTracker = () => {
  const location = useLocation()
  const isInitialLoad = useRef(true)

  useEffect(() => {
    if (!MEASUREMENT_ID || typeof window.gtag !== 'function') {
      return
    }

    if (isInitialLoad.current) {
      isInitialLoad.current = false
      return
    }

    window.gtag('config', MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    })
  }, [location])

  return null
}

export default GoogleAnalyticsRouteTracker
